import { QuizAnswers, QuestionAnswerPayload } from './types'

import { client } from 'src/utils/client'
import config from 'src/config'

export const getQuizAnswers = async (
  quizId: number,
  otherUserId: string
): Promise<QuizAnswers> =>
  await client(
    `${config.HOST_API}/quiz-answers?quizId=${String(
      quizId
    )}&otherUserId=${otherUserId}`
  )

export const answerQuiz = async (answers: QuestionAnswerPayload[]) =>
  await client(`${config.HOST_API}/quiz-answers`, { body: answers })
